export default __webpack_public_path__ + "static/media/pestilentialblasr.edae1688.png";